import React, { useEffect, useState } from "react";
import { Filter, FloatRight, ListView, PagesHeader } from "../../components/Categories";
import { useSelector } from "react-redux";
import { useDispatch } from "react-redux";
import Page from "../../components/Common/Page";
import { getCategoriesList } from "../../appRedux/actions/categories";

const CategoryList = () => {
  const dispatch = useDispatch();
  const [initialFetchComplete, setInitialFetchComplete] = useState(false);
  const [searchText, setSearchText] = useState("");
  const [viewStatus, setViewStatus] = useState("listView"); //"listView", "gridView"
  const categoryList = useSelector((state) => state.categories.categoryList);
  console.log({ categoryList });

  useEffect(() => {
    dispatch(getCategoriesList({ page: 1, size: 10 })).then(() => {
      setInitialFetchComplete(true);
    });
  }, [dispatch]);
  return (
    <Page title="Category">
      <div className="page-wrapper">
        {/* Page Content */}
        <div className="content container-fluid">
          {/* Page Header */}
          <PagesHeader
            pageTitle={"Category List"}
            homePageUrl="/"
            homePageText="Dashboard"
            // innerPageUrl={""}
            // innerPageText={""}
            activePageText={"Categories"}
            floatRight={
              <FloatRight viewStatus={viewStatus} onChange={(status) => setViewStatus(status)} />
            }
          />
          {/* /Page Header */}
          <Filter {...{ initialFetchComplete,searchText, setSearchText }} />
          {/* <EmployeeListFilter /> */}

          <div className="card">
            <div className="card-body">
              <ListView {...{searchText}}/>
            </div>
          </div>
        </div>
        {/* /Page Content */}
      </div>
    </Page>
  );
};

export default CategoryList;
